var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"textarea"},[_c('idf-standard-inputs',{attrs:{"id":_vm.id,"label":_vm.label}},[_c('textarea',{attrs:{"id":_vm.id},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }